<form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()" class="p-3 border rounded">
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-checkbox [formControl]="form.get('isPhysical')"
                [config]="formConfiguration.isPhysical"></app-checkbox>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-checkbox [formControl]="form.get('isJuridical')"
                [config]="formConfiguration.isJuridical"></app-checkbox>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-checkbox [formControl]="form.get('isPublicAdmin')"
                [config]="formConfiguration.isPublicAdmin"></app-checkbox>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-checkbox [formControl]="form.get('isDirect')" 
                [config]="formConfiguration.isDirect"></app-checkbox>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('streetTypeId')" [config]="formConfiguration.streetType"> </app-select>
        </div>
        <div class="col-md-4 col-lg-6 col-xs-12">
            <app-input [formControl]="form.get('address')" [config]="formConfiguration.address"></app-input>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('number')" [config]="formConfiguration.number"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('block')" [config]="formConfiguration.block"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('entrance')" [config]="formConfiguration.entrance"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('staircase')" [config]="formConfiguration.staircase"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('floor')" [config]="formConfiguration.floor"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('door')" [config]="formConfiguration.door"></app-input>
        </div>
    </div>

    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('countriesCode')" [config]="formConfiguration.countriesCode">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('provinceCode')" [config]="formConfiguration.provinceCode">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('municipalityCode')" [config]="formConfiguration.municipalityCode">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('postalCode')" [config]="formConfiguration.postalCode"></app-input>
        </div>
    </div>

    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('email')" [config]="formConfiguration.email"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('residenceTypeId')" [config]="formConfiguration.residenceTypeId">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('bankAccount')" [config]="formConfiguration.bankAccount"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('bic')" [config]="formConfiguration.bic">
            </app-select>
        </div>
    </div>

    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('phone')" [config]="formConfiguration.phone"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('contactPerson')" [config]="formConfiguration.contactPerson"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('taxRepresentativeNIF')"
                [config]="formConfiguration.taxRepresentativeNIF"></app-input>
        </div>
    </div>
</form>